import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-resume-incomplete-store-setup-body",
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule],
  templateUrl: "./resume-incomplete-store-setup-body.component.html",
  styleUrls: ["./resume-incomplete-store-setup-body.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResumeIncompleteStoreSetupBodyComponent {
  @Input() userName = "there";
  @Input() momentStep = "resumeIncompleteStoreSetup";
  @Output() continue = new EventEmitter<void>();

  onContinue(): void {
    this.continue.emit();
  }
}
